import gql from 'graphql-tag';

const FRAGMENT_STUDENT_INFO = gql`
  fragment fragmentPersonDetailQueryStudentInfo on Student {
    id
    originId
    email
    gender
    account {
      id
      originId
      email
      editInfo {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
    firstName
    middleName
    lastName
  }
`;

export const QUERY_COUNTRIES = gql`
  query SP_QueryCountries($nameLike: String) {
    getCountries(nameLike: $nameLike) {
      countries {
        id
        name
        slug
        countryCode
        currencyCode
        dialingCountryCode
        nationality
      }
    }
  }
`;

export const QUERY_UNIVERSITIES = gql`
  query SP_QueryUniversities($nameLike: String, $cityId: ID) {
    getUniversities(nameLike: $nameLike, cityId: $cityId) {
      universities {
        id
        originId
        name
        slug
        latitude
        longitude
      }
    }
  }
`;

export const QUERY_CITIES = gql`
  query SP_QueryCities($nameLike: String, $countryId: ID) {
    getCities(nameLike: $nameLike, countryId: $countryId) {
      cities {
        id
        originId
        name
        slug
        latitude
        longitude
      }
    }
  }
`;

export const MUTATION_PERSONAL_DETAIL = gql`
  mutation SP_MutationPersonalDetail($input: studentFillPersonalDetailInput!) {
    studentFillPersonalDetail(input: $input) {
      id
      status
      countDown
      referral
      contracts {
        id
        name
        content
      }
      curationTicket {
        id
        status
      }
      documents {
        id
        name
        status
        stage
        fileUuid
        category
        mandatory
        description
        rejectedReason
      }
      customFieldValues {
        id
        customFieldId
        customFieldType
        labelName
        value
        customFieldInputOnBookingJourney
        customFieldMandatoryOnBookingJourney
      }
      currentGuarantorSetting {
        id
        academicYearId
        guarantorType
        guarantorTypeLabelName
        guarantorTypeDescription
      }
      latestAmendmentDetail {
        amendmentMilestone
      }
    }
  }
`;

export const AMENDMENT_MUTATION_PERSONAL_DETAIL = gql`
  mutation SP_AmendmentMutationPersonalDetail($input: studentFillPersonalDetailInput!) {
    studentFillPersonalDetailForAmendment(input: $input) {
      id
      status
      countDown
      contracts {
        id
        name
        content
      }
      curationTicket {
        id
        status
      }
      documents {
        id
        name
        status
        stage
        fileUuid
        category
        mandatory
        description
        rejectedReason
      }
      customFieldValues {
        id
        customFieldId
        customFieldType
        labelName
        value
        customFieldInputOnBookingJourney
        customFieldMandatoryOnBookingJourney
      }
      currentGuarantorSetting {
        id
        academicYearId
        guarantorType
        guarantorTypeLabelName
        guarantorTypeDescription
      }
      latestAmendmentDetail {
        amendmentMilestone
      }
    }
  }
`;

export const MUTATION_STUDENT_CANCEL_BOOKING_COUNTDOWN = gql`
  mutation SP_MutationStudentCancelBookingCountDown($bookingId: ID!) {
    studentCancelBookingCountDown(bookingId: $bookingId) {
      status
    }
  }
`;

export const QUERY_FIELD_SETTINGS_BY_MODEL = gql`
  query SP_QueryFieldSettingByModel($topLandlordId: ID!, $model: CustomFieldModelTypeOptions!) {
    getFieldSettingsByModel(topLandlordId: $topLandlordId, model: $model) {
      id
      modelType
      fieldFormat
      type
      labelName
      picklistOptions {
        name
        value
      }
      fieldName
      inputTypeInForm
    }
  }
`;

export const MUTATION_STUDENT_FILL_GUARANTOR_DETAILS = gql`
  mutation SP_MutationStudentFillGuarantorDetails($input: studentFillGuarantorDetailsInput!) {
    studentFillGuarantorDetails(input: $input) {
      id
      status
      contracts {
        id
        name
        content
      }
      curationTicket {
        id
        status
      }
      currentGuarantorSetting {
        id
        academicYearId
        guarantorType
        guarantorTypeLabelName
        guarantorTypeDescription
      }
      latestAmendmentDetail {
        amendmentMilestone
      }
      guarantors {
        id
        relationship
        firstName
        middleName
        lastName
        title
        dateOfBirth
        countryTerritory
        cityTown
        cityTownId
        countryTerritoryId
        taxCountryTerritory
        taxCountryTerritoryId
        postcode
        addressLine1
        addressLine2
        mobilePhoneAreaCode
        mobilePhoneNumber
        mobilePhone
        homePhoneAreaCode
        homePhoneNumber
        homePhone
        contactEmail
        customFieldValues {
          id
          customFieldId
          customFieldType
          labelName
          value
          customFieldInputOnBookingJourney
          customFieldMandatoryOnBookingJourney
        }
        documents {
          id
          documentSettingId
          name
          status
          stage
          fileUuid
          category
          mandatory
          description
          rejectedReason
        }
        guarantorReferenceNumber
        guarantorType
      }
    }
  }
`;

export const MUTATION_STUDENT_FILL_GUARANTOR_DETAILS_FOR_AMENDMENT = gql`
  mutation SP_MutationStudentFillGuarantorDetailsForAmendment(
    $input: studentFillGuarantorDetailsInput!
  ) {
    studentFillGuarantorDetailsForAmendment(input: $input) {
      id
      status
      contracts {
        id
        name
        content
      }
      curationTicket {
        id
        status
      }
      currentGuarantorSetting {
        id
        academicYearId
        guarantorType
        guarantorTypeLabelName
        guarantorTypeDescription
      }
      latestAmendmentDetail {
        amendmentMilestone
      }
      guarantors {
        id
        relationship
        firstName
        middleName
        lastName
        title
        dateOfBirth
        countryTerritory
        cityTown
        cityTownId
        countryTerritoryId
        taxCountryTerritory
        taxCountryTerritoryId
        postcode
        addressLine1
        addressLine2
        mobilePhoneAreaCode
        mobilePhoneNumber
        mobilePhone
        homePhoneAreaCode
        homePhoneNumber
        homePhone
        contactEmail
        customFieldValues {
          id
          customFieldId
          customFieldType
          labelName
          value
          customFieldInputOnBookingJourney
          customFieldMandatoryOnBookingJourney
        }
        documents {
          id
          documentSettingId
          name
          status
          stage
          fileUuid
          category
          mandatory
          description
          rejectedReason
        }
        guarantorReferenceNumber
        guarantorType
      }
    }
  }
`;
